import Axios from 'axios'
import store from '@/store/store'
import notify from 'devextreme/ui/notify'
import DXSTORE from 'devextreme/data/custom_store'
import router from '../../../../router/router'


const URL = 'api/system/user'

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== '';
}


const $Store = new DXSTORE({
    key: 'id',
    load: function (loadOptions) {

        let params = '?';
        [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary'
        ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
        });
        debugger;
        params = params.slice(0, -1);
        var str = store;

        //get active or inactive?
        var inactive = str.getters["sysUsers/showInactive"]

        params = (params.length === 0 ?
            ('?active=' + (!inactive ? 1 : 0))
            :
            (params + '&active=' + (!inactive ? 1 : 0))
        )

        return str.dispatch("accounts/getAccounts")
            .then(() => {
                return Axios.get(URL + params)
                    .then(response => {
                        debugger
                        if (response.data.success) {
                            debugger
                            var rsp = {
                                data: response.data.msg.data,
                                totalCount: response.data.msg.totalCount,
                            }

                            debugger;
                            return rsp
                        } else {
                            notify(response.data.msg, 'error', 4000)
                            return { data: [], totalCount: 0 }
                        }
                    })
                    .catch(err => {
                        notify('Can\'t load users right now, ' + err.message, 'error')
                        str.dispatch('updateStat', false)
                    })
            })
            .catch(err => {
                notify('Can\'t load users right now, ' + err.message, 'error')
                str.dispatch('updateStat', false)
            })

    }
})

const $SaStore = new DXSTORE({
    key: 'id',
    load: function (loadOptions) {

        let params = '?';
        [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary'
        ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
        });

        params = params.slice(0, -1);
        var str = store;

        // str.dispatch("updateState", true);

        debugger
        //get active or inactive?
        var inactive = str.getters["sysUsers/showInactive"]

        params = (params.length === 0 ?
            ('?active=' + (!inactive ? 1 : 0))
            :
            (params + '&active=' + (!inactive ? 1 : 0))
        )

        return str.dispatch("sysUsers/saUsers", params)
            .then(rsp => {

                debugger;
                var sas = rsp;
                return {
                    data: sas,
                    totalCount: sas.length,
                }
            })
            .catch(err => {
                notify('Can\'t load users right now, ' + err.message, 'error')
                str.dispatch('updateStat', false)
            })

    }
})

export default {
    namespaced: true,
    state: {
        users: [],
        totalCount: 0,
        dxStore: $Store,
        dxSaStore: $SaStore,
        showInactive: false
    },
    mutations: {
        setUsers(state, usrs) {
            debugger
            state.users = usrs.msg.data ? usrs.msg.data : []
            state.totalCount = usrs.msg.totalCount ? usrs.msg.totalCount : 0
        },
        updateUser(state, usr) {
            if (!usr) {
                return;
            }

            var user = state.users.find(u => u.email === usr.email);

            if (!user) {
                // notify('User not found!');
                state.users.push(usr);
                return;
            }

            user.first_





        },
        setStat(state, stat = false) {
            state.showInactive = stat;
        },

    },
    actions: {
        async refreshUsersAsync({ commit }) {
            debugger
            this.dispatch('updateStat', true)
            return Axios.get(URL)
                .then(response => {
                    commit('setUsers', response.data)
                    this.dispatch('updateStat', false)
                    return;
                })
                .catch(err => {
                    notify('Can\'t load users right now, ' + err.message, 'error')
                    this.dispatch('updateStat', false)
                })
        },
        async saUsers({ commit }, params = '') {



            return Axios.get('api/system/saf' + params)
                .then(rsp => {
                    return rsp.data.msg.length > 0 ? rsp.data.msg : [];
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    return []
                })
        },
        async registerUserAsync({ commit }, usr) {
            if (!usr) {
                notify('User can\'t be null!');
                return;
            }

            return Axios.post(URL,
                usr)
                .then(response => {
                    debugger;
                    // commit('updateUser', response.data);
                    return this.dispatch('sysUsers/refreshUsersAsync')
                        .then(() => {
                            debugger
                            var type = response.data.success ? 'success' : 'error'
                            var msg = response.data.success ? 'User was successfully added!' : response.data.msg
                            notify(msg, type, 4000)
                            return response.data.success;
                        });
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    return false;
                })
        },
        async updateUserAsync({ commit }, usr) {
            var user = usr;
            return Axios.put('api/system/user' + '?id=' + usr.id,
                user
            )
                .then(response => {
                    debugger;
                    var type = response.data.success ? 'success' : 'error'
                    var msg = response.data.success ? 'Changes saved.' : response.data.msg
                    notify(msg, type, 4000);
                    return response.data.success
                })
                .catch(err => {
                    debugger;

                    notify(err.message, 'error', 4000)
                })
        },
        async sendWelcomeMsg({ commit }, id) {
            return Axios.get('api/system/welcome?id=' + id)
                .then(rsp => {
                    var type = rsp.data.success ? 'success' : 'error';
                    notify(rsp.data.msg, type, 4000);

                    return rsp.data.success;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return false;
                })
        },
        showInactive({ commit }, inactive = false) {
            commit('setStat', inactive)
            return;
        }
    },
    getters: {
        users: state => state.users,
        store: state => state.dxStore,
        saStore: state => state.dxSaStore,
        showInactive: state => state.showInactive
    }

}


// WEBPACK FOOTER //
// ./src/store/modules/admin/LinkDSG/dsgUsers.js